import ItemChannelTab from "./ItemChannelTab/ItemChannelTab";

function ChannelTab({ activeTab, chooseActiveTab }) {

    return (
        <div className="flex flex-row-reverse items-center px-10 pt-4 border-b border-slate-200">
            <ItemChannelTab
                text="ورود محتوا"
                num={0}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
            <ItemChannelTab
                text="لیست محتوا"
                num={1}
                activeTab={activeTab}
                onClick={chooseActiveTab}
            />
        </div>
    )
}
export default ChannelTab;